export const InspectButtonValue = {
  CIRCLE: 1,
  CROSS: 2,
  TRIANGLE: 3,
  FREE: 4,
  NOPRIORITY: 0
};

/*  circle = pass
    crosss = not pass
    triangle = should change
*/
